import { useCool } from "/@/cool";

const getMultilingual = async () => {
	const service = useCool();
	const data = await service.service.multilingual.all();
	return data;
};

export default getMultilingual;
